import en from "./en";
import jp from "./jp";
import ko from "./ko";

const LOCALES = { ko, en, jp };

/**
 * shopify 내부에서 문구를 꺼낼 때 쓴다. 앱의 i18next 초기화 여부와 무관하게 동작해야 해서
 * t() 대신 로케일 객체를 직접 인덱싱한다 (쿼리 훅은 이미 lang 을 prop 으로 받는다).
 *
 * jp 는 ko/en 의 부분집합이라 반환 타입을 ko 기준으로 맞춘다. 여기서 꺼내 쓰는 키는
 * 세 파일 모두에 있는 것만 쓸 것.
 */
export function locale(lang: "ko" | "en" | "jp"): typeof ko {
  return (LOCALES[lang] ?? ko) as typeof ko;
}
